module.exports = __webpack_public_path__ + "static/media/refil-noblesse.90309b01.jpg";